import { call, put, takeLatest, takeEvery, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import {
  contactForm,
  contactUsForm,
  subscribeForm,
  feedbackForm,
  getForm,
  submitForm
} from './api';
import {
  CONTACT_FORM_REQUEST,
  CONTACT_US_FORM_REQUEST,
  FORM_REQUESTING,
  RESET_FORM_ISFETCHING,
  SUBSCRIBE_FORM_REQUEST,
  FEEDBACK_FORM_REQUEST,
  GET_FORM_REQUEST,
  GET_FORM_SUCCESS,
  SUBMIT_RESPONSE_REQUEST
} from './constants';

export function* get(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: FORM_REQUESTING });
    const response = yield call(getForm, action.code);
    yield put({ type: GET_FORM_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    yield put({ type: RESET_FORM_ISFETCHING });
    yield call(addAPIError, error);
    return null;
  }
}

export function* submit(action) {
  try {
    yield call(removeAPIError);
    const formResponse = action.response;
    formResponse.channel = 'Web';
    const response = yield call(submitForm, formResponse, action.formId);
    action.successFunction(response.data);
  } catch (error) {
    action.failFunction(error);
  }
}

export function* contact(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: FORM_REQUESTING });
    const response = yield call(contactForm, action.form);
    action.successFunction(response.data);
  } catch (error) {
    yield put({ type: RESET_FORM_ISFETCHING });
    action.failFunction(error);
  }
}

export function* contactUs(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: FORM_REQUESTING });
    const response = yield call(contactUsForm, action.form);
    if (action.successFunction) {
      action.successFunction(response.data);
    }
    return response.data;
  } catch (error) {
    yield put({ type: RESET_FORM_ISFETCHING });
    yield call(addAPIError, error);
    return null;
  }
}

export function* subscribe(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: FORM_REQUESTING });
    const response = yield call(subscribeForm, action.form);
    action.successFunction(response.data);
  } catch (error) {
    yield put({ type: RESET_FORM_ISFETCHING });
    action.failFunction(error);
  }
}

export function* feedback(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: FORM_REQUESTING });
    const response = yield call(feedbackForm, action.form);
    action.successFunction(response.data);
  } catch (error) {
    yield put({ type: RESET_FORM_ISFETCHING });
    action.failFunction(error);
  }
}

export function* watchList() {
  yield takeLatest(CONTACT_FORM_REQUEST, contact);
  yield takeLatest(CONTACT_US_FORM_REQUEST, contactUs);
  yield takeLatest(SUBSCRIBE_FORM_REQUEST, subscribe);
  yield takeLatest(FEEDBACK_FORM_REQUEST, feedback);
  yield takeEvery(GET_FORM_REQUEST, get);
  yield takeLatest(SUBMIT_RESPONSE_REQUEST, submit);
}

export default function* formsSagas() {
  yield all([watchList()]);
}
